import { render, staticRenderFns } from "./Recuperacion.vue?vue&type=template&id=69ed3890"
import script from "./Recuperacion.vue?vue&type=script&lang=js"
export * from "./Recuperacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports